import { useQuery, useMutation, useQueryClient } from "react-query";
import { adminWebauthnApi } from "../api/adminWebauthnApi";

const KEY = ["webauthn", "admin-requests"];

/** Admin: list enrollment requests and approve/reject them. */
export function useAdminRequests() {
  const qc = useQueryClient();

  const list = useQuery(KEY, () => adminWebauthnApi.listRequests());

  const invalidate = () => qc.invalidateQueries(["webauthn", "admin-requests"]);

  const approve = useMutation((id) => adminWebauthnApi.approveRequest(id), {
    onSuccess: invalidate,
  });
  const reject = useMutation(
    ({ id, reason }) => adminWebauthnApi.rejectRequest(id, reason),
    { onSuccess: invalidate }
  );

  return { list, approve, reject };
}
